import { useEffect, useState } from 'react';
import { getOrCreateViewerId } from '../utils/viewerIdentity';

export function useViewerIdentity() {
  const initialId = typeof window !== 'undefined' ? getOrCreateViewerId() : null;
  const [viewerId, setViewerId] = useState<string | null>(initialId);

  useEffect(() => {
    if (!viewerId) {
      setViewerId(getOrCreateViewerId());
    }
  }, [viewerId]);

  return { viewerId };
}
